import React from 'react'
import { useEffect as UseEffect, useState as UseState } from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import TypographyComponent from '../../components/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import informationService from '../../services/system';

const index = ({ user, id }) => {

    const [contability, setContability] = UseState([]);
    const [collapsedStatesContabilidad, setCollapsedStatesContabilidad] = UseState(false);
    const [totales, setTotales] = UseState({});
    UseEffect(() => {
        if (id) {
            informationService.searchContability(`${user.data.instance}`, id).then((response) => {
                setContability(response.data);
                let flagTotales = {
                    amountDebitFx: 0,
                    amount: 0,
                    amountCreditFx: 0,
                    amountFx: 0,
                    amountDebit: 0,
                    amountCredit: 0,
                };

                for (let h = 0; h < response.data.length; h++) {
                    if (response.data[h].amountDebitFx) {
                        let amountDebitFx = Number(response.data[h].amountDebitFx).toFixed(2)
                        flagTotales.amountDebitFx = (Number(flagTotales.amountDebitFx) + Number(amountDebitFx)).toFixed(2);
                    }

                    let amount = Number(response.data[h].amount).toFixed(2)
                    flagTotales.amount = (Number(flagTotales.amount) + Number(amount)).toFixed(2);

                    if (response.data[h].amountCreditFx) {
                        let amountCreditFx = Number(response.data[h].amountCreditFx).toFixed(2)
                        flagTotales.amountCreditFx = (Number(flagTotales.amountCreditFx) + Number(amountCreditFx)).toFixed(2);
                    }

                    let amountFx = Number(response.data[h].amountFx).toFixed(2)
                    flagTotales.amountFx = (Number(flagTotales.amountFx) + Number(amountFx)).toFixed(2);

                    if (response.data[h].amountDebit) {
                        let amountDebit = Number(response.data[h].amountDebit).toFixed(2)
                        flagTotales.amountDebit = (Number(flagTotales.amountDebit) + Number(amountDebit)).toFixed(2);
                    }

                    if (response.data[h].amountCredit) {
                        let amountCredit = Number(response.data[h].amountCredit).toFixed(2)
                        flagTotales.amountCredit = (Number(flagTotales.amountCredit) + Number(amountCredit)).toFixed(2);
                    }
                }

                let amountDebitFx = flagTotales.amountDebitFx.toString().split('.');
                amountDebitFx = `${amountDebitFx[0]},${amountDebitFx[1] ? amountDebitFx[1].slice(0, 2) : '00'}`
                amountDebitFx = formatNumberWithThousandsSeparator(amountDebitFx);
                flagTotales.amountDebitFx = amountDebitFx;

                let amount = flagTotales.amount.toString().split('.');
                amount = `${amount[0]},${amount[1] ? amount[1].slice(0, 2) : '00'}`
                amount = formatNumberWithThousandsSeparator(amount);
                flagTotales.amount = amount;

                let amountCreditFx = flagTotales.amountCreditFx.toString().split('.');
                amountCreditFx = `${amountCreditFx[0]},${amountCreditFx[1] ? amountCreditFx[1].slice(0, 2) : '00'}`
                amountCreditFx = formatNumberWithThousandsSeparator(amountCreditFx);
                flagTotales.amountCreditFx = amountCreditFx;

                let amountFx = flagTotales.amountFx.toString().split('.');
                amountFx = `${amountFx[0]},${amountFx[1] ? amountFx[1].slice(0, 2) : '00'}`
                amountFx = formatNumberWithThousandsSeparator(amountFx);
                flagTotales.amountFx = amountFx;

                let amountDebit = flagTotales.amountDebit.toString().split('.');
                amountDebit = `${amountDebit[0]},${amountDebit[1] ? amountDebit[1].slice(0, 2) : '00'}`
                amountDebit = formatNumberWithThousandsSeparator(amountDebit);
                flagTotales.amountDebit = amountDebit;

                let amountCredit = flagTotales.amountCredit.toString().split('.');
                amountCredit = `${amountCredit[0]},${amountCredit[1] ? amountCredit[1].slice(0, 2) : '00'}`
                amountCredit = formatNumberWithThousandsSeparator(amountCredit);
                flagTotales.amountCredit = amountCredit;

                setTotales(flagTotales);
            }).catch((error => {
                console.log(error)
            }))
        }
    }, []);

    const handleToggleCollapseContabilidad = () => {

        if (collapsedStatesContabilidad)
            setCollapsedStatesContabilidad(false)
        else
            setCollapsedStatesContabilidad(true);
    };

    const formatNumberWithThousandsSeparator = (num) => {
        const parts = num.split(',');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return parts.join(',');
    };

    return (
        <Box border={1} borderColor="rgb(0 0 0 / 13%)" borderRadius="4px" p={2} padding={1}>

            <Box display="flex" alignItems="center">
                <IconButton onClick={() => handleToggleCollapseContabilidad()}>
                    {collapsedStatesContabilidad ? (<ExpandLessIcon />) : (<ExpandMoreIcon />)}
                </IconButton>
                <TypographyComponent
                    paragraphType='body1'
                    text='Contabilidad'
                />
            </Box>
            {collapsedStatesContabilidad && (
                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <Table>
                        <TableHead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                            <TableRow>
                                <TableCell>Cuenta Contable</TableCell>
                                <TableCell style={{ textAlign: 'center'}}>Debe</TableCell>
                                <TableCell style={{ textAlign: 'center'}}>Haber</TableCell>
                                <TableCell style={{ textAlign: 'center'}}>Importe</TableCell>
                                <TableCell>Moneda</TableCell>
                                <TableCell style={{ textAlign: 'center'}}>Tipo Cambio</TableCell>
                                <TableCell style={{ textAlign: 'center'}}>Importe Moneda</TableCell>
                                <TableCell style={{ textAlign: 'center'}}>Debe</TableCell>
                                <TableCell style={{ textAlign: 'center'}}>Haber</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {contability.map((item, index) => {
                                let amountDebitFx = '0,00';
                                if (item.amountDebitFx) {
                                    amountDebitFx = item.amountDebitFx.split('.');
                                    amountDebitFx = `${amountDebitFx[0]},${amountDebitFx[1].slice(0, 2)}`
                                    amountDebitFx = formatNumberWithThousandsSeparator(amountDebitFx);
                                }

                                let amountCreditFx = '0,00';
                                if (item.amountCreditFx) {
                                    amountCreditFx = item.amountCreditFx.split('.');
                                    amountCreditFx = `${amountCreditFx[0]},${amountCreditFx[1].slice(0, 2)}`
                                    amountCreditFx = formatNumberWithThousandsSeparator(amountCreditFx);
                                }

                                let amountFx = item.amountFx.split('.');
                                amountFx = `${amountFx[0]},${amountFx[1].slice(0, 2)}`
                                amountFx = formatNumberWithThousandsSeparator(amountFx);

                                let fxRate = item.fxRate.split('.');
                                fxRate = `${fxRate[0]},${fxRate[1].slice(0, 2)}`
                                fxRate = formatNumberWithThousandsSeparator(fxRate);

                                let amount = item.amount.split('.');
                                amount = `${amount[0]},${amount[1].slice(0, 2)}`
                                amount = formatNumberWithThousandsSeparator(amount);

                                let amountDebit = '0,00';
                                if (item.amountDebit) {
                                    amountDebit = item.amountDebit.split('.');
                                    amountDebit = `${amountDebit[0]},${amountDebit[1].slice(0, 2)}`
                                    amountDebit = formatNumberWithThousandsSeparator(amountDebit);
                                }

                                let amountCredit = '0,00';
                                if (item.amountCredit) {
                                    amountCredit = item.amountCredit.split('.');
                                    amountCredit = `${amountCredit[0]},${amountCredit[1].slice(0, 2)}`
                                    amountCredit = formatNumberWithThousandsSeparator(amountCredit);
                                }

                                return <TableRow key={index}>
                                    <TableCell>{item.account}</TableCell>
                                    <TableCell style={{ fontVariantNumeric: 'tabular-nums',textAlign: 'right', letterSpacing: '0.01rem' }}>{Number(item.amountDebitFx) !== 0 ? amountDebitFx : ""}</TableCell>
                                    <TableCell style={{ fontVariantNumeric: 'tabular-nums',textAlign: 'right', letterSpacing: '0.01rem' }}>{Number(item.amountCreditFx) !== 0 ? amountCreditFx : ""}</TableCell>
                                    <TableCell style={{ fontVariantNumeric: 'tabular-nums',textAlign: 'right', letterSpacing: '0.01rem' }}>{Number(item.amountFx) !== 0 ? amountFx : ""}</TableCell>
                                    <TableCell>{item.currency}</TableCell>
                                    <TableCell style={{ fontVariantNumeric: 'tabular-nums',textAlign: 'right', letterSpacing: '0.01rem' }}>{fxRate}</TableCell>
                                    <TableCell style={{ fontVariantNumeric: 'tabular-nums',textAlign: 'right', letterSpacing: '0.01rem' }}>{Number(item.amount) !== 0 ? amount : ""}</TableCell>
                                    <TableCell style={{ fontVariantNumeric: 'tabular-nums',textAlign: 'right', letterSpacing: '0.01rem' }}>{Number(item.amountDebit) !== 0 ? amountDebit : ""}</TableCell>
                                    <TableCell style={{ fontVariantNumeric: 'tabular-nums',textAlign: 'right', letterSpacing: '0.01rem' }}>{Number(item.amountCredit) !== 0 ? amountCredit : ""}</TableCell>
                                </TableRow>
                            })}
                            <TableRow key={index}>
                                <TableCell></TableCell>
                                <TableCell style={{ fontVariantNumeric: 'tabular-nums',textAlign: 'right', letterSpacing: '0.01rem' }}>{totales.amountDebitFx}</TableCell>
                                <TableCell style={{ fontVariantNumeric: 'tabular-nums',textAlign: 'right', letterSpacing: '0.01rem' }}>{totales.amountCreditFx}</TableCell>
                                <TableCell style={{ fontVariantNumeric: 'tabular-nums',textAlign: 'right', letterSpacing: '0.01rem' }}>{totales.amountFx}</TableCell>
                                <TableCell></TableCell>
                                <TableCell style={{ fontVariantNumeric: 'tabular-nums',textAlign: 'right', letterSpacing: '0.01rem' }}></TableCell>
                                <TableCell style={{ fontVariantNumeric: 'tabular-nums',textAlign: 'right', letterSpacing: '0.01rem' }}>{totales.amount}</TableCell>
                                <TableCell style={{ fontVariantNumeric: 'tabular-nums',textAlign: 'right', letterSpacing: '0.01rem' }}>{totales.amountDebit}</TableCell>
                                <TableCell style={{ fontVariantNumeric: 'tabular-nums',textAlign: 'right', letterSpacing: '0.01rem' }}>{totales.amountCredit}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </div>
            )}
        </Box>
    )
}

export default index;